export default __webpack_public_path__ + "static/media/icon-sprite.32f9baa3.svg";